<template>
  <v-container fluid fill-height pa-0>
    <v-layout>
      <v-flex>
        <v-layout align-center>
          <v-spacer></v-spacer>
          <div class="pr-2">
            <v-switch v-model="notInUse" label="Not in Use"></v-switch>
          </div>
          <div class="pr-2">
            <v-switch v-model="isActive" label="Active"></v-switch>
          </div>
          <div class="pr-2">
            <v-switch v-model="emailVerified" label="Email Verified"></v-switch>
          </div>
          <list-visible-columns-and-filter
            v-model="search"
            :visible-columns="visibleColumns"
            :selectable-headers="selectableHeaders"
            @change="onVisibleColumnsChange"
          />
          <v-tooltip bottom v-if="showNewUser">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                fab
                dark
                color="primary"
                @click="onNewStaff"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Create New User</span>
          </v-tooltip>
        </v-layout>
        <v-layout fluid>
          <v-flex xs12>
            <v-card outlined>
              <v-data-table
                :headers="filteredHeaders"
                :items="items"
                :loading="$apollo.loading"
                v-bind="pagingOptions"
                :search="search"
                item-key="node.id"
              >
                <template v-slot:item.node.lastLogin="{ item }">{{
                  item.node.lastLogin | formatDate
                }}</template>
                <template v-slot:item.node.isActive="{ item }">
                  <v-simple-checkbox
                    v-model="item.node.isActive"
                    :disabled="true"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.node.notInUse="{ item }">
                  <v-simple-checkbox
                    v-model="item.node.notInUse"
                    :disabled="true"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.node.emailVerified="{ item }">
                  <v-simple-checkbox
                    v-model="item.node.emailVerified"
                    :disabled="true"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-layout row>
                    <default-list-actions
                      :item="item"
                      :hide-view="true"
                      :itemName="'user'"
                      :hideEdit="hideEdit"
                      :hideRemove="hideRemove"
                      @deleteItem="deleteItem($event)"
                      @viewItem="viewItem($event)"
                      @editItem="editItem($event)"
                    >
                      <template slot="extraButton">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              small
                              class="mx-0"
                              v-if="showClone"
                              @click="cloneItem(item)"
                            >
                              <v-icon color="primary" small
                                >mdi-content-copy</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>Copy</span>
                        </v-tooltip>
                      </template>
                    </default-list-actions>
                  </v-layout>
                </template>
              </v-data-table>
            </v-card>
            <v-row align="center" justify="center">
              <div class="caption">
                <strong>Total Active:</strong> {{ totalActive }},
                <strong>Total Not in Use:</strong> {{ totalNotInUse }},
                <strong>Max Total:</strong>
                {{ $store.getters.userConfig.maxUsers }}
              </div>
            </v-row>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-row v-if="false">
      <add-btn
        label="Add New Staff"
        icon="mdi-account"
        @click="onNewStaff"
      ></add-btn>
    </v-row>
    <agent-staff-edit-dialog
      v-model="editedStaff"
      :show="showStaffEditDialog"
      @close="showStaffEditDialog = false"
      @save="onSave"
    ></agent-staff-edit-dialog>
    <clone-staff
      :show="showCloneStaff"
      v-model="selectedStaff"
      @close="showCloneStaff = false"
      @complete="onCloneComplete"
    ></clone-staff>
    <div v-if="debug">{{ items.length }}</div>
  </v-container>
</template>

<script>
import {
  USER_CREATE_MUTATION,
  AGENT_STAFF_LIST,
  USER_UPDATE_MUTATION,
  USER_DELETE_MUTATION,
} from "../../../constants/graphql";
import GetMoreResults from "../shared/GetMoreResults";
import DefaultListActions from "../shared/DefaultListActions";
import UserEditor from "./users/UserEditor";
import { pagingOptions, sortByDate } from "../../../helpers/index";
import AddBtn from "../shared/AddBtn";
import AgentStaffEditDialog from "./AgentStaffEditDialog";
import CloneStaff from "./CloneStaff";
import EventBus from "../../../store/event-bus";
import ListVisibleColumnsAndFilter from "../shared/ListVisibleColumnsAndFilter.vue";
import SimpleListMixin from "../../../mixins/SimpleListMixin";
export default {
  name: "AgentEditorStaff",

  props: {
    agent: {
      type: Object,
      default: () => ({}),
    },
  },

  mixins: [SimpleListMixin],

  components: {
    GetMoreResults,
    DefaultListActions,
    AddBtn,
    AgentStaffEditDialog,
    CloneStaff,
    ListVisibleColumnsAndFilter,
  },

  data() {
    return {
      debug: false,
      notInUse: false,
      isActive: true,
      emailVerified: true,
      pagingOptions,
      editedStaff: {},
      showCloneStaff: false,
      selectedStaff: null,
      search: "",
      showStaffEditDialog: false,
      headers: [
        {
          text: "Username",
          align: "right",
          value: "node.username",
          name: "username",
        },
        {
          text: "Name",
          align: "right",
          value: "node.name",
          name: "name",
        },
        {
          text: "Email",
          align: "right",
          value: "node.email",
          name: "email",
        },
        {
          text: "Active",
          align: "right",
          value: "node.isActive",
          name: "isActive",
        },
        {
          text: "Not in Use",
          align: "center",
          value: "node.notInUse",
          name: "notInUse",
        },
        {
          text: "Email Verified",
          align: "center",
          value: "node.emailVerified",
          name: "emailVerified",
        },
        {
          text: "Last Login",
          align: "center",
          value: "node.lastLogin",
          name: "lastLogin",
          sort: sortByDate,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "username",
        "name",
        "email",
        "actions",
      ]),
    };
  },

  computed: {
    selectableHeaders() {
      return this.headers.filter(
        (h) => h.name != "menuActions" //&&  h.name != "actions"
      );
    },
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
    hideRemove() {
      if (this.agent && this.agent.isOwner) {
        //https://tracker.globetrack.ie/issues/7735
        return !this.$store.getters.hasAccessTo(
          "administration_panel:user_access_control"
        );
      }
      return false;
    },
    hideEdit() {
      return false;
      if (this.agent && this.agent.isOwner) {
        //https://tracker.globetrack.ie/issues/7735
        return !this.$store.getters.hasAccessTo("agents:edit_user");
      }
      return false;
    },
    showClone() {
      if (this.agent && this.agent.isOwner) {
        //https://tracker.globetrack.ie/issues/7735
        return (
          this.$store.getters.hasAccessTo("administration_panel:user_copy") &&
          this.$store.getters.hasAccessTo("agents:edit_user")
        );
      }
      return true;
    },
    showNewUser() {
      if (this.agent && this.agent.isOwner) {
        //https://tracker.globetrack.ie/issues/7735
        return (
          this.$store.getters.hasAccessTo(
            "administration_panel:user_access_control"
          ) && this.$store.getters.hasAccessTo("agents:edit_user")
        );
      }
      return true;
    },
    totalActive() {
      return this.items.filter((i) => i.node.isActive).length;
    },
    totalNotInUse() {
      return this.items.filter((i) => i.node.notInUse).length;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      return this.users && this.users.edges ? [...this.users.edges] : [];
    },
    agentAccessSettings() {
      return this.agent.accessSettings.reduce((accessSettings, setting) => {
        accessSettings[setting.groupName] = accessSettings[setting.groupName]
          ? accessSettings[setting.groupName]
          : {};

        accessSettings[setting.groupName][setting.settingName] =
          setting.settingValue;

        return accessSettings;
      }, {});
    },
  },

  methods: {
    cloneItem(item) {
      this.selectedStaff = { ...item.node };
      this.showCloneStaff = true;
    },
    onCloneComplete(payload) {
      this.$store.dispatch("showAppSnackbar", {
        msg: `${payload.username} Created.`,
      });
      this.showCloneStaff = false;
      if (this.$apollo.queries.users != null) {
        this.$apollo.queries.users.refetch();
      }
    },
    onSave(payload) {
      this.saveStaff(payload);
    },
    onNewStaff() {
      this.editedStaff = {};
      this.showStaffEditDialog = true;
    },
    editItem(item) {
      this.editedStaff = { ...item.node };
      this.showStaffEditDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: USER_DELETE_MUTATION,
          variables: {
            id: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "User removed." });
      if (this.$apollo.queries.users != null) {
        this.$apollo.queries.users.refetch();
      }
    },
    saveStaff(user) {
      const mutation =
        user.id != null ? USER_UPDATE_MUTATION : USER_CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: {
            ...user,
            agentId: this.agent.id,
          },
        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    closeUserEditorDialog() {
      this.showStaffEditDialog = false;
    },
    saveGqlObjectHandler() {
      if (this.$apollo.queries.users != null) {
        this.$apollo.queries.users.refetch();
      }
      const msg = this.editedStaff.id ? "User Updated." : "User Created.";
      this.$store.dispatch("showAppSnackbar", { msg, color: "success" });
      this.showStaffEditDialog = false;
      EventBus.$emit("reloadStaffList");
    },

    saveGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");

      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
      console.log(JSON.stringify(err));
    },
  },
  apollo: {
    users: {
      query: AGENT_STAFF_LIST,
      variables() {
        return {
          filter: {
            agent_id: this.agent.id,
            not_in_use_eq: this.notInUse,
            is_active_eq: this.isActive,
            email_verified_eq: this.emailVerified,
          },
        };
      },
      skip() {
        return this.agent.id == null;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentEditorStaff.vue